export default "__VITE_ASSET__I0uxRRJL__"